module.exports = __webpack_public_path__ + "media/images/placeholder/placeholder-people-3ea7a0926c98679c2f03d7353f24288b.jpg";